<template>
  <div class="race-card-wrapper row no-gutters h-100">
    <div class="col-12">
      <div
        class="row no-gutters justify-content-center align-items-center py-2 race-card-header"
      >
        <div
          class="col-12 justify-content-center align-items-center text-center pdf-content"
          ref="pdfContent"
        >
          <h1 v-if="!showRaceCourseLogoTitle" class="mt-2">
            {{ raceCard.raceCardSummary.courseTitle }}
          </h1>
          <img
            v-if="showRaceCourseLogoTitle"
            id="raceCardTopImage"
            :src="
              getImage(
                raceCourseAssets[raceCard.raceCardSummary.raceTrackAssetId]
                  .raceCourseTitleLogoWhitePath,
                'svg',
                raceCourseAssets[raceCard.raceCardSummary.raceTrackAssetId]
                  .raceCourseTitleLogoWhitePath,
                'raceCardTopImage',
              )
            "
            class="mt-2 race-course-title-logo"
            :ref="'raceCourseLogoTitle'"
          />

          <div class="text">{{ getSubtitle() }}</div>
          <div class="text">{{ selectedRace.raceByRace.date }}</div>
        </div>
      </div>
      <div
        id="race-numbers"
        class="row no-gutters d-flex justify-content-center align-items-center"
      >
        <div
          v-if="showScrollTopButton"
          class="col-12 no-gutters text-center justify-content-center"
        >
          <button class="race-card-scroll-header mb-1 px-4 text">
            {{
              raceCourseAssets[raceCard.raceCardSummary.raceTrackAssetId]
                .raceCourseTitle
            }}
            -
            {{ selectedRace.raceByRace.details.split("-")[1] | timetocolon }} -
            {{ selectedRace.raceByRace.details.split("-")[2] }}
          </button>
        </div>
        <img
          v-if="selectedRaceCardHorseIndex"
          @click="onBackButtonClicked()"
          :src="getImage('white-arrow-back')"
          class="back-button"
          :ref="'whiteArrow'"
        />
        <div id="addedDiv" class="raceNumberContainer">
          <div class="col-sm-6 col-lg-6 px-2 text-center">
            <button
              class="race-number-button"
              v-for="(race, index) in raceCard.raceInformation"
              :key="index"
              v-bind:class="{
                'race-number-button-selected':
                  selectedRace.raceByRace.raceNumber - 1 === index,
              }"
              @click="onRaceSelected(index)"
              v-tooltip="'Race ' + (index + 1) + ''"
            >
              {{ index + 1 }}
            </button>
          </div>
          <button @click="exportPDF()" class="exportToPdfButton">
            <img src="../assets/images/PDFIcon.svg" />
          </button>
        </div>
      </div>
      <div class="race-card-body" id="pdfSelection">
        <div class="row no-gutters col-12 p-0">
          <RaceCardBanners />
        </div>
        <div
          class="row no-gutters justify-content-space-evenly align-items-center mb-md-2 mt-lg-4"
        >
          <div class="col-12 col-lg-4 order-lg-2 pt-2 mb-4">
            <div class="row no-gutters">
              <div class="col-12 text-center">
                <div class="row no-gutters justify-content-center">
                  <button class="race-card-info-header px-4 py-2 text">
                    {{ selectedRace.raceByRace.details | trType }}
                  </button>
                </div>
                <div
                  class="row no-gutters justify-content-center font-weight-bold"
                >
                  <span class="font-italic flex-nowrap">{{
                    selectedRace.raceByRace.sponsor
                  }}</span>
                </div>
                <div
                  class="row no-gutters justify-content-center font-weight-bold"
                >
                  <span class="font-italic flex-nowrap">{{
                    selectedRace.raceByRace.meritRating
                  }}</span>
                </div>

                <div class="row no-gutters justify-content-center">
                  <span class="font-italic flex-nowrap">{{
                    amrRaceEditedText
                      ? amrRaceEditedText
                      : "&nbsp;" | colondecimal
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-4 col-lg-3 order-lg-1 my-2 text-center">
            <img
              :ref="'raceCardCourse'"
              id="raceCardCourse"
              class="race-card-course-image img-fluid"
              :src="
                getImage(
                  `${
                    raceCourseAssets[raceCard.raceCardSummary.raceTrackAssetId]
                      .raceCourseIcon
                  }-${
                    raceCard.raceInformation[
                      selectedRace.raceByRace.raceNumber - 1
                    ].distance
                  }`,
                  'svg',
                  `${
                    raceCourseAssets[raceCard.raceCardSummary.raceTrackAssetId]
                      .raceCourseIcon
                  }`,
                  'raceCardCourse',
                )
              "
            />
          </div>
          <div class="col-7 col-lg-3 order-lg-3 mt-lg-2">
            <div class="row no-gutters align-items-center">
              <div class="col-11">
                <div class="row no-gutters">
                  <div
                    class="col-5 d-flex justify-content-center mr-2 simple-border"
                  >
                    <table>
                      <tr>
                        <td class="px-2 flex-nowrap">Bipot</td>
                        <td class="px-2 flex-nowrap">
                          {{
                            selectedRace.raceByRace.exoticStarts.biPot || "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-2">PA</td>
                        <td class="px-2">
                          {{
                            selectedRace.raceByRace.exoticStarts
                              .placeAccumulator || "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-2">P6</td>
                        <td class="px-2">
                          {{
                            selectedRace.raceByRace.exoticStarts.pickSix || "-"
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td class="px-2">JP</td>
                        <td class="px-2">
                          {{
                            selectedRace.raceByRace.exoticStarts.jackpot || "-"
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                  <div
                    class="col-6 d-flex justify-content-center simple-border"
                  >
                    <table>
                      <tr
                        v-for="(racePrizePoolItem, index) in selectedRace
                          .raceByRace.racePrizePool"
                        :key="index"
                      >
                        <td
                          v-if="index === 0"
                          class="font-weight-bold px-2 flex-nowrap"
                        >
                          {{
                            racePrizePoolItem
                              | currency("R", 0, {
                                thousandsSeparator: " ",
                                spaceBetweenAmountAndSymbol: true,
                              })
                          }}
                        </td>
                        <td
                          v-if="index > 0 && racePrizePoolItem"
                          class="px-2 flex-nowrap"
                        >
                          {{ index }}.
                          {{
                            racePrizePoolItem
                              | currency("R", 0, { thousandsSeparator: " " })
                          }}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="row no-gutters justify-content-space-evenly my-1 px-1 px-md-2 d-md-none"
        >
          <div class="field-statistics col-12 justify-content-center">
            <table class="col-12 col-md-4 text-center">
              <tr>
                <td class="text-center flex-nowrap font-weight-bold">
                  Same Trainer:
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  {{ selectedRace.raceByRace.fieldInformation.sameTrainer }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  Magic Tips:
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  {{ selectedRace.raceByRace.fieldInformation.magicTips }}
                </td>
              </tr>
            </table>
            <table class="col-12">
              <tr>
                <td class="text-center flex-nowrap font-weight-bold">
                  Field statistics:
                </td>
                <td class="text-center flex-nowrap font-weight-bold">Runs:</td>
                <td class="text-center flex-nowrap">
                  {{ selectedRace.raceByRace.fieldInformation.fieldStatsRuns }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">Wins:</td>
                <td class="text-center flex-nowrap">
                  {{ selectedRace.raceByRace.fieldInformation.fieldStatsWins }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  Places:
                </td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.fieldStatsPlaces
                  }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  Stakes:
                </td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.fieldStatsStakes
                  }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">Wins:</td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation
                      .fieldStatsWinPercentage
                  }}
                </td>
              </tr>
              <tr>
                <td class="text-center flex-nowrap font-weight-bold">
                  Average per runner:
                </td>
                <td class="text-center flex-nowrap font-weight-bold">Runs:</td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsRuns
                  }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">Wins:</td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsWins
                  }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  Places:
                </td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsPlaces
                  }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  Stakes:
                </td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsStakes
                  }}
                </td>
                <td class="text-center flex-nowrap font-weight-bold">
                  Places:
                </td>
                <td class="text-center flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation
                      .fieldStatsPlacePercentage
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div
          class="row no-gutters justify-content-space-evenly mb-2 px-1 px-md-2 d-none d-md-block"
        >
          <div class="field-statistics col-12 justify-content-center py-2">
            <table class="col-md-12">
              <tr class="text-center mb-1">
                <td class="flex-nowrap font-weight-bold">Same Trainer:</td>
                <td class="text-left flex-nowrap font-weight-bold">
                  {{ selectedRace.raceByRace.fieldInformation.sameTrainer }}
                </td>
                <td class="flex-nowrap font-weight-bold">Field statistics:</td>
                <td class="flex-nowrap font-weight-bold">Runs:</td>
                <td class="text-left flex-nowrap">
                  {{ selectedRace.raceByRace.fieldInformation.fieldStatsRuns }}
                </td>
                <td class="flex-nowrap font-weight-bold">Wins:</td>
                <td class="text-left flex-nowrap">
                  {{ selectedRace.raceByRace.fieldInformation.fieldStatsWins }}
                </td>
                <td class="flex-nowrap font-weight-bold">Places:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.fieldStatsPlaces
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">Stakes:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.fieldStatsStakes
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">Wins:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation
                      .fieldStatsWinPercentage
                  }}
                </td>
              </tr>
              <tr class="text-center mb-1">
                <td class="flex-nowrap font-weight-bold">Magic Tips:</td>
                <td class="text-left flex-nowrap font-weight-bold">
                  {{ selectedRace.raceByRace.fieldInformation.magicTips }}
                </td>
                <td class="flex-nowrap font-weight-bold">
                  Average per runner:
                </td>
                <td class="flex-nowrap font-weight-bold">Runs:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsRuns
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">Wins:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsWins
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">Places:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsPlaces
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">Stakes:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation.avgFieldStatsStakes
                  }}
                </td>
                <td class="flex-nowrap font-weight-bold">Places:</td>
                <td class="text-left flex-nowrap">
                  {{
                    selectedRace.raceByRace.fieldInformation
                      .fieldStatsPlacePercentage
                  }}
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div class="row no-gutters">
          <div class="col-12">
            <div class="row no-gutters mb-4 mb-lg-1">
              <div class="col-6 mb-1 col-lg-3 mb-lg-2 text-center">
                <button
                  v-bind:class="{
                    'tab-header-clicked': raceDetailsTabStates.predictedFinish,
                  }"
                  v-on:click="onRaceDetailsTabClicked('predictedFinish')"
                  class="extra-info-button"
                >
                  Predicted Finish
                </button>
              </div>
              <div class="col-6 mb-1 col-lg-3 mb-lg-2 text-center">
                <button
                  v-bind:class="{
                    'tab-header-clicked': raceDetailsTabStates.raceComments,
                  }"
                  v-on:click="onRaceDetailsTabClicked('raceComments')"
                  class="extra-info-button"
                >
                  Race Comments
                </button>
              </div>
              <div class="col-6 col-lg-3 text-center">
                <button
                  v-bind:class="{
                    'tab-header-clicked':
                      raceDetailsTabStates.trainerJockeyCombo,
                  }"
                  v-on:click="onRaceDetailsTabClicked('trainerJockeyCombo')"
                  class="extra-info-button"
                >
                  Trainer/Jockey Combo
                </button>
              </div>
              <div class="col-6 col-lg-3 text-center">
                <button
                  v-bind:class="{
                    'tab-header-clicked': raceDetailsTabStates.barrierDraw,
                  }"
                  v-on:click="onRaceDetailsTabClicked('barrierDraw')"
                  class="extra-info-button"
                >
                  Barrier Draw
                </button>
              </div>
            </div>
            <div class="row no-gutters d-flex justify-content-center">
              <race-card-predicted-finish
                v-if="raceDetailsTabStates.predictedFinish"
                :predictedFinish="selectedRace.raceByRace.predictedFinish"
              ></race-card-predicted-finish>
              <race-card-race-comments
                v-if="raceDetailsTabStates.raceComments"
                :raceComments="selectedRace.raceByRace.raceComments"
              ></race-card-race-comments>
              <race-card-trainer-jockey-combo
                v-if="raceDetailsTabStates.trainerJockeyCombo"
                :trainerJockeyCombo="selectedRace.raceByRace.trainerJockeyCombo"
              ></race-card-trainer-jockey-combo>
              <race-card-barrier-draw
                v-if="raceDetailsTabStates.barrierDraw"
                :barrierDraw="selectedRace.raceByRace.barrierDraw"
              ></race-card-barrier-draw>
            </div>
          </div>
        </div>
        <race-card-team-details
          class="mb-1 mb-lg-4"
          v-for="(runner, index) in selectedRace.raceByRace.runners"
          :key="index"
          :openFormGridCallback="openFormGridCallback"
          :isBettingAllowed="areBetsAllowed"
          :timeHasRunOutForBetting="timeHasRunOut"
          :runner="runner"
          :index="index"
          v-bind:id="index"
        ></race-card-team-details>
        <div class="w-100 collateral-header text-center py-2">
          <span class="text"> COLLATERAL </span>
        </div>
        <div
          v-if="selectedRace.raceByRace.collateral.runnerGrouping.length > 0"
          class="row no-gutters justify-content-space-evenly collateral-table"
        >
          <div style="position: relative" class="col-12 px-2">
            <div id="team-details-table" class="table-responsive">
              <table class="table">
                <thead class="thead-dark">
                  <tr>
                    <th scope="col">DATE</th>
                    <th scope="col">CRS</th>
                    <th scope="col">RACE CLASS</th>
                    <th scope="col">G</th>
                    <th scope="col">DIST</th>
                    <th scope="col">HORSE</th>
                    <th scope="col">FP</th>
                    <th scope="col">LTH</th>
                    <th scope="col">DR/RN</th>
                    <th scope="col">WINNER/2ND</th>
                    <th scope="col">JOCKEY THN</th>
                    <th scope="col">WGT THN</th>
                    <th scope="col">JOCKEY NOW</th>
                    <th scope="col">WGT NOW</th>
                  </tr>
                </thead>
                <tbody
                  v-for="(runnerGroup, index) in selectedRace.raceByRace
                    .collateral.runnerGrouping"
                  :key="index"
                  class="collateral-grouping"
                >
                  <tr
                    v-for="(runner, index) in runnerGroup.runnerDetail"
                    :key="index"
                  >
                    <td class="highlighted-table-cell">{{ runner.date }}</td>
                    <td id="courseType">{{ runner.course }}</td>
                    <td>{{ runner.race }}</td>
                    <td>{{ runner.going }}</td>
                    <td>{{ runner.distance }}</td>
                    <td
                      class="font-italic text-left clickable-text"
                      v-on:click="onHorseNameClicked('name')"
                    >
                      {{ runner.horse }}
                    </td>
                    <td>
                      <img
                        :ref="'cell' + Date.now()"
                        v-on:click="
                          openFormGridCallback(
                            runnerGroup.id,
                            runner.finishPosition,
                          )
                        "
                        :src="
                          getImage(
                            'wf-finishing-position-' + runner.finishPosition,
                            'svg',
                            null,
                            'wf-finishing-position-' +
                              runner.finishPosition +
                              runnerGroup.id,
                          )
                        "
                        :id="
                          'wf-finishing-position-' +
                          runner.finishPosition +
                          runnerGroup.id
                        "
                        class="finishing-position-icon"
                      />
                    </td>
                    <td>{{ runner.lengthBehind | lthdecimal }}</td>
                    <td class="font-weight-bold">{{ runner.drawRunners }}</td>
                    <td>{{ runner.winnerOrSecond | todecimal | winner }}</td>
                    <td
                      class="font-italic text-left clickable-text"
                      v-on:click="onJockeyNameClicked('name')"
                    >
                      {{ runner.jockey | jockinit }}
                    </td>
                    <td class="text-center text-lg-left">
                      {{ runner.weightThen | wgtdecimal }}
                    </td>
                    <td
                      class="font-italic text-left clickable-text"
                      v-on:click="onJockeyNameClicked('name')"
                    >
                      {{ runner.jockeyNow | jockinit }}
                    </td>
                    <td class="text-center text-lg-left">
                      {{ runner.weightNow | wgtdecimal }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div style="height: 5rem; width: 100vw"></div>
      </div>
    </div>
    <div
      v-if="showNavigationBar"
      id="race-numbers-bottom"
      class="row no-gutters d-flex justify-content-center align-items-center pt-0 bottom-navbar"
    >
      <div class="col-12 text-center no-gutters justify-content-center pt-0">
        <button class="race-card-scroll-header mb-1 px-4 text">
          {{
            raceCourseAssets[raceCard.raceCardSummary.raceTrackAssetId]
              .raceCourseTitle
          }}
          - {{ selectedRace.raceByRace.details.split("-")[1] }} -
          {{ selectedRace.raceByRace.details.split("-")[2] }}
        </button>
      </div>
      <img
        v-if="selectedRaceCardHorseIndex"
        @click="onBackButtonClicked()"
        :src="getImage('white-arrow-back')"
        class="back-button"
        :ref="'whiteArrowBack'"
      />
      <div class="col-12 col-sm-8 col-lg-6 px-2 text-center">
        <button
          class="col-1 race-number-button"
          v-for="(race, index) in raceCard.raceInformation"
          :key="index"
          v-bind:class="{
            'race-number-button-selected':
              selectedRace.raceByRace.raceNumber - 1 === index,
          }"
          @click="onRaceSelected(index)"
        >
          {{ index + 1 }}
        </button>
      </div>
    </div>
    <img
      id="backToTop"
      v-if="showScrollTopButton"
      class="back-to-top-button btn"
      :src="
        getImage(
          'fixtures-dropdown-icon',
          'svg',
          raceCourseAssets[raceCard.raceCardSummary.raceTrackAssetId]
            .raceCourseTitleLogoWhitePath,
          'backToTop',
        )
      "
      v-on:click="scrollToTop()"
      :ref="'raceCardInfo' + index"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import RaceCardTeamDetails from "../components/RaceCardTeamDetails";
import RaceCardRaceComments from "../components/RaceCardRaceComments";
import RaceCardPredictedFinish from "../components/RaceCardPredictedFinish";
import RaceCardTrainerJockeyCombo from "../components/RaceCardTrainerJockeyCombo";
import RaceCardBarrierDraw from "../components/RaceCardBarrierDraw";
import { raceCardHorsesMockData } from "../assets/mockData/raceCardHorses";
import { RaceCardService } from "../services/raceCard.service";
import { RaceCourseAssets } from "../components/configuration/raceCourseAssetMapping.constant";
import { FormGridService } from "../services/formGrid.service";
import { CollateralFormLinesMock } from "../assets/mockData/collateral";
import jockeyTrainer from "../components/mixins/Jockey-TrainerName";
import { trackLogoId } from "../../config";

import { ExportHTMLtoPDF, convertSVGToBase64 } from "../services/ExportToPdf";
import RaceCardBanners from "../components/RaceCardBanners.vue";

export default {
  name: "RaceCard",
  mixins: [jockeyTrainer],
  components: {
    RaceCardTeamDetails,
    RaceCardRaceComments,
    RaceCardPredictedFinish,
    RaceCardTrainerJockeyCombo,
    RaceCardBarrierDraw,
    RaceCardBanners,
  },
  data: function () {
    return {
      overrideRaceImages: {
        "Saturday - 04 July 2026": [3, 4, 5, 6, 7, 8, 9, 10],
      },
      overrideRaceDates: ["Saturday - 04 July 2026"],
      currentlySelectedRace: 1,
      raceCard: {},
      showNavigationBar: false,
      showScrollTopButton: false,
      raceCourseAssets: RaceCourseAssets,
      raceDetailsTabStates: {
        raceComments: false,
        predictedFinish: false,
        trainerJockeyCombo: false,
        barrierDraw: false,
      },
      raceCardHorsesMockData: raceCardHorsesMockData,
      collateralFormData: CollateralFormLinesMock,
      msg: "This is a button.",
      showRaceCourseLogoTitle: false,
    };
  },
  filters: {
    colondecimal: function (value) {
      value = value.toString();
      if (value != null && !value.includes(".")) {
        value = value + ".0";
        value = value.replace(".", ":");
        return value;
      } else if (value != null && value.includes(".")) {
        value = value.replace(".", ":");
        return value;
      } else {
        return value;
      }
    },

    todecimal: function (value) {
      value = value.toString();
      if (value != null && !value.includes(".")) {
        var v = value.substr(0, value.indexOf(")"));
        v = v + ".0)";
        return v;
      } else {
        return value;
      }
    },
    lthdecimal: function (value) {
      value = value.toString();
      if (value != null && !value.includes(".")) {
        value = value + ".00";
        return value;
      } else if (value != null && value.includes(".") && value.length < 4) {
        value = value + "0";
        return value;
      } else if (
        value != null &&
        value.includes(".") &&
        value.length == 4 &&
        value.slice(-1) != 0
      ) {
        var newString = value.substr(0, value.indexOf("."));
        if (newString.length > 1) {
          value = value + "0";
        }
        return value;
      } else {
        return value;
      }
    },

    wgtdecimal: function (value) {
      value = value.toString();
      if (value != null && !value.includes(".")) {
        value = value + ".0";
        return value;
      } else {
        return value;
      }
    },
    trType: function (value) {
      value = value.toString();
      if (value.includes("(S)")) {
        value = value.replace(".", ":");
        value = value.replace("(S)", "");
        return value;
      } else if (value.includes("(B)")) {
        value = value.replace(".", ":");
        value = value.replace("(B)", "");
        return value;
      } else {
        return value;
      }
    },
    timetocolon: function (value) {
      value = value.toString();
      if (value != null && value.includes(".")) {
        value = value.replace(".", ":");
        return value;
      }
    },
    jockinit: function (value) {
      value = value.toString();
      if (value != null && value == "Veale S") {
        value = "S Veale";
        return value;
      } else {
        return value;
      }
    },
  },
  computed: {
    areBetsAllowed: function () {
      if (this.selectedRace.raceByRace.details) {
        const timeMatch =
          this.selectedRace.raceByRace.details.match(/\b\d{2}\.\d{2}\b/);
        const time = timeMatch[0].replace(".", ":");
        const dateIndex = this.selectedRace.raceByRace.date.indexOf("-") + 1;
        const date = this.selectedRace.raceByRace.date.slice(
          dateIndex,
          this.selectedRace.raceByRace.date.length,
        );

        const combinedDate = new Date(`${date} ${time}`);
        const formattedDate = combinedDate.toLocaleString("en-za");
        const newDateObj = new Date(formattedDate);
        const diff = newDateObj.getTime() - Date.now();
        if (Date.now() < newDateObj.getTime()) {
          this.startTimer(Math.round(diff / 1000));
          return true;
        }
        return false;
      }
    },
    amrRaceEditedText: function () {
      return (
        (this.selectedRace.raceByRace.averageFieldMeritRating &&
        this.selectedRace.raceByRace.averageFieldMeritRating > 0
          ? "AMR - " +
            this.selectedRace.raceByRace.averageFieldMeritRating +
            " | "
          : "") +
        (this.selectedRace.raceByRace.averageWinningTime &&
        this.selectedRace.raceByRace.averageWinningTime > 0
          ? "Ave C&D Time - " + this.selectedRace.raceByRace.averageWinningTime
          : "")
      );
    },
    ...mapState([
      "selectedRace",
      "selectedRaceCard",
      "isFormGridOpen",
      "selectedRaceCardHorseIndex",
    ]),
  },
  methods: {
    startTimer(val) {
      this.timerValue = val;
      this.intervalId = setInterval(() => {
        if (this.timerValue !== 0) {
          this.timerValue--;
        } else {
          clearInterval(this.intervalId);
          this.timeHasRunOut = true;
        }
      }, 1000);
    },
    isDurbanJulyTurfRaces() {
      return (
        this.selectedRace.raceByRace.raceNumber !== "1" &&
        this.selectedRace.raceByRace.raceNumber !== "2" &&
        this.selectedRace.raceByRace.raceNumber !== "12" &&
        this.raceCard.raceCardSummary.raceDate === "Saturday - 05 July 2025" &&
        this.raceCard.raceCardSummary.courseTitle === "Hollywoodbets Greyville"
      );
    },
    getSubtitle() {
      if (this.isDurbanJulyTurfRaces()) {
        return "Course - Poly";
      }

      if (
        this.overrideRaceDates.includes(
          this.raceCard.raceCardSummary.raceDate,
        ) &&
        this.raceCard.raceCardSummary.courseTitle ==
          "Hollywoodbets Greyville" &&
        this.overrideRaceImages[
          this.raceCard.raceCardSummary.raceDate
        ].includes(this.currentlySelectedRace)
      ) {
        return "Course - Turf";
      } else {
        return this.raceCard.raceCardSummary.courseSubTitle;
      }
    },
    getImage(imagePath, fileType = "svg", defaultRaceCoursePath, element) {
      if (this.isDurbanJulyTurfRaces()) {
        imagePath = imagePath.replace(
          "racecourse-greyville-poly",
          "racecourse-greyville-turf",
        );
      }

      if (
        this.overrideRaceDates.includes(
          this.raceCard.raceCardSummary.raceDate,
        ) &&
        this.raceCard.raceCardSummary.courseTitle ==
          "Hollywoodbets Greyville" &&
        this.overrideRaceImages[
          this.raceCard.raceCardSummary.raceDate
        ].includes(this.currentlySelectedRace)
      ) {
        imagePath = imagePath.replace(
          "racecourse-greyville-poly",
          "racecourse-greyville-turf",
        );
      }

      try {
        const t = require("../assets/images/" + imagePath + "." + fileType);

        if (element) {
          if (t.slice(-3) === "svg" && element != "raceCardTopImage") {
            convertSVGToBase64(element, t);
          } else {
            return require("../assets/images/" + imagePath + "." + fileType);
          }
        }
      } catch (e) {
        if (
          this.overrideGreyvilleDates.includes(
            this.raceCard.raceCardSummary.raceDate,
          ) &&
          this.raceCard.raceCardSummary.courseTitle ==
            "Hollywoodbets Greyville" &&
          this.overrideGreyvilleImages.includes(this.currentlySelectedRace)
        ) {
          imagePath = imagePath.replace(
            "racecourse-greyville-poly",
            "racecourse-greyville-turf",
          );
        }

        try {
          return require("../assets/images/" + imagePath + "." + fileType);
        } catch (e) {
          return require("../assets/images/" +
            defaultRaceCoursePath +
            "." +
            fileType);
        }
      }
    },
    openFormGridCallback(id, index) {
      this.setSelectedFormGridHorseIndex(parseInt(index, 10));
      FormGridService.getFormGrid(id, this.onFormGridDataResponse.bind(this));
    },
    onFormGridDataResponse() {
      this.toggleFormGridVisibility();
    },
    toggleFormGridVisibility() {
      this.setIsFormGridOpen(!this.isFormGridOpen);
    },
    onRaceDetailsTabClicked(tabName) {
      for (let tab in this.raceDetailsTabStates) {
        if (this.raceDetailsTabStates[tab] && tabName === tab) {
          this.raceDetailsTabStates[tab] = false;
          return;
        }
        this.raceDetailsTabStates[tab] = tab === tabName;
      }
    },
    onScroll(scrollingElement) {
      const raceNumbersElement = document.getElementById("race-numbers"),
        stickyTrigger = raceNumbersElement.offsetTop,
        scrollToTop = scrollingElement.scrollingElement
          ? scrollingElement.scrollingElement.scrollTop
          : scrollingElement.scrollTop,
        toggleCheck =
          window.innerWidth < 1200
            ? this.showNavigationBar
            : raceNumbersElement.classList.contains("sticky-race-numbers");

      this.showScrollTopButton = scrollToTop > 10;
      if (scrollToTop > stickyTrigger && !toggleCheck) {
        window.innerWidth < 1200
          ? (this.showNavigationBar = true)
          : raceNumbersElement.classList.toggle("sticky-race-numbers");
      } else if (
        (scrollToTop < stickyTrigger || scrollToTop === 0) &&
        toggleCheck
      ) {
        window.innerWidth < 1200
          ? (this.showNavigationBar = false)
          : raceNumbersElement.classList.toggle("sticky-race-numbers");
      }
    },
    flushRaceDetailsTabStates() {
      this.raceDetailsTabStates = {
        raceComments: false,
        predictedFinish: false,
        trainerJockeyCombo: false,
        barrierDraw: false,
      };
    },
    onRaceSelected(raceIndex) {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.timeHasRunOut = false;
      }
      this.currentlySelectedRace = raceIndex + 1;
      this.setIsLoading(true);
      this.flushRaceDetailsTabStates();
      const raceCardId = this.raceCard.raceInformation[raceIndex].id;
      RaceCardService.getRace(raceCardId, this.onRaceResponse.bind(this));
    },
    onRaceResponse(race) {
      this.setSelectedRace(race);
      this.setIsLoading(false);
      this.scrollToTop();
    },
    scrollToTop() {
      const scrollableElement = document.querySelector(".race-card-wrapper");
      scrollableElement.scrollTo(0, 0);
    },
    initRaceCardData() {
      this.raceCard = this.selectedRaceCard;
    },
    initRaceCardFromRouter(race) {
      this.raceCard = race;
    },
    // eslint-disable-next-line no-unused-vars
    onHorseNameClicked(horseNameId) {
      this.setSelectedHorse({});
    },
    // eslint-disable-next-line no-unused-vars
    onJockeyNameClicked(jockeyNameId) {
      this.setSelectedJockey({});
    },
    onBackButtonClicked() {
      window.history.back();
    },
    goToPdf(url) {
      window.open(url, "_blank");
    },
    onRaceCardResponse(response) {
      const selectedRace = response;
      this.setSelectedRace(selectedRace);
      this.initRaceCardData();
    },
    formatDateToMatchDB(dateString) {
      const dateObj = new Date(dateString);
      const options = {
        weekday: "long",
        day: "2-digit",
        month: "long",
        year: "numeric",
      };
      const formattedDate = dateObj
        .toLocaleDateString("en-GB", options)
        .replace(/(\w+),? (\d{2}) (\w+) (\d{4})/, "$1 - $2 $3 $4");
      return formattedDate;
    },
    onRaceCardSummariesResponse(response) {
      const { date, course, rn } = this.$route.params;

      let resolvedCourseName = course
        .split("-")
        .filter((str) => str != "poly")
        .join(" ")
        .toLowerCase()
        .trimEnd();

      const formattedDate = this.formatDateToMatchDB(date);

      const selectedRaceSummary = response.find(
        (summary) =>
          summary.raceCardSummary.raceDate === formattedDate &&
          resolvedCourseName.includes(
            summary.raceCardSummary.courseTitle.toLowerCase().trimEnd(),
          ),
      );

      if (!selectedRaceSummary) {
        this.$router.push({ path: `/landing/home` });
        return;
      }
      this.setSelectedRaceCard(selectedRaceSummary);

      const raceIndex = parseInt(rn) - 1;
      if (
        raceIndex < 0 ||
        raceIndex >= selectedRaceSummary.raceInformation.length
      ) {
        this.$router.push({ path: `/landing/home` });
        return;
      }
      RaceCardService.getRace(
        selectedRaceSummary.raceInformation[raceIndex].id,
        this.onRaceCardResponse.bind(this),
      );
    },
    getAllSummaries() {
      RaceCardService.getRaceCardSummaries(
        this.onRaceCardSummariesResponse.bind(this),
      );
    },
    exportPDF() {
      const html = document.getElementById("pdfSelection");
      ExportHTMLtoPDF(html);
    },

    ...mapMutations([
      "setSelectedRace",
      "setIsLoading",
      "setIsFormGridOpen",
      "setSelectedFormGridHorseIndex",
      "setSelectedRaceCardHorseIndex",
      "setSelectedRaceCard",
    ]),
  },

  created: function () {
    const { date, course, rn } = this.$route.params;
    const isValidDate = (dateStr) => /^\d{4}-\d{2}-\d{2}$/.test(dateStr);

    if (!date && !course && !rn) {
      if (this.selectedRaceCard) {
        this.initRaceCardData();
      } else {
        this.$router.push({ path: `/landing/home` });
      }
      return;
    }

    if (
      date &&
      course &&
      rn &&
      isValidDate(date) &&
      course.trim() !== "" &&
      !isNaN(Number(rn))
    ) {
      this.getAllSummaries();
    } else {
      this.$router.push({ path: `/landing/home` });
    }
  },

  mounted: function () {
    const { raceTrackAssetId } = this.selectedRaceCard.raceCardSummary;
    const showRaceCourseLogoTitleIds = trackLogoId.showRaceCourseLogoTitleIds;
    this.showRaceCourseLogoTitle =
      showRaceCourseLogoTitleIds.indexOf(parseInt(raceTrackAssetId, 10)) > -1;
    this.showNavigationBar = false;
    window["showNavigationBar"] = this.showNavigationBar;
    this.boundScrollCallback = this.onScroll.bind(
      this,
      document.querySelector(".race-card-wrapper"),
    );
    if (document.querySelector(".race-card-wrapper")) {
      document
        .querySelector(".race-card-wrapper")
        .addEventListener("scroll", this.boundScrollCallback);
      if (
        this.selectedRaceCardHorseIndex &&
        document.getElementById(`${this.selectedRaceCardHorseIndex - 1}`)
      ) {
        const selectedHorseElement = document.getElementById(
          `${this.selectedRaceCardHorseIndex - 1}`,
        );
        const raceNumbersHeight = document
          .getElementById("race-numbers")
          .getBoundingClientRect().height;
        const raceCardWrapper = document.querySelector(".race-card-wrapper");
        const offsetScroll =
          window.innerWidth > 768
            ? raceNumbersHeight + 35 + raceCardWrapper.offsetTop
            : 0;
        document
          .querySelector(".race-card-wrapper")
          .scrollTo(0, selectedHorseElement.offsetTop - offsetScroll);
      }
    }
  },
  beforeDestroy: function () {
    this.setSelectedRaceCardHorseIndex(undefined);
    if (document.querySelector(".race-card-wrapper"))
      document
        .querySelector(".race-card-wrapper")
        .removeEventListener("scroll", this.boundScrollCallback);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.raceNumberContainer {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
}

.exportToPdfButton {
  position: absolute;
  right: 0;
  height: 100%;
  color: #000000;
  border: solid 2px black;
  border-radius: 3px !important;
  background: transparent;
  font-size: 0.5rem;
  font-weight: bold;
}

.exportToPdfButton:hover {
  background: transparent;
}

.exportToPdfButton img {
  position: relative;
  height: 100%;
}

.back-button {
  position: absolute;
  z-index: 100;
  left: 0;
  height: 50px;
  width: 50px;
}

.race-card-wrapper {
  overflow-x: hidden;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.race-card-header {
  background-color: #000000;
}
.printerImg {
  position: absolute;
  top: -42px;
  right: -100px;
  width: 100px;
}
.race-number-button {
  margin-right: 0.05rem;
  padding: 0.4rem;
  text-align: center;
  font-size: 0.7rem;
  font-weight: bold;
  color: #ffffff;
  background-color: transparent;
  border: solid 1px #ffffff;
  width: 8%;
}

.race-number-button-selected {
  background-color: #ffffff;
  color: #000000;
  cursor: pointer;
}

.race-number-button:hover {
  background-color: #ffffff;
  color: #000000;
  cursor: pointer;
}

.race-card-body {
  background-color: #ffffff;
  border-top: solid 1px #000000;
}

.race-card-info-header {
  background-color: #000000;
  border-radius: 0.4rem;
  border: none;
  font-size: 1rem;
  margin-bottom: 1rem;
}

.race-card-scroll-header {
  background-color: #000000;
  border-radius: 0.4rem;
  border: none;
  font-size: 0.7rem;
  margin-bottom: 1rem;
}

.race-card-info-header:hover {
  background-color: #000000 !important;
  cursor: auto;
}

.simple-border {
  border: solid 2px #000000;
}

.extra-info-button {
  width: 95%;
  background-color: #ffffff;
  border: solid 2px #000000;
  font-size: 0.6rem;
  font-weight: bold;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.3);
  border-radius: 3px;
  padding: 0.3rem 0;
}

.bottom-navbar {
  width: 100vw;
  display: block;
  position: fixed;
  bottom: 0;
  padding: 0.25rem 0 1.5rem 0 !important;
}

.table-responsive {
  border: 1px solid #7c7c7c !important;
  margin-bottom: 0.5rem !important;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.4);
}

button:hover {
  background-color: #f0f0f0;
  cursor: pointer;
}

td {
  font-size: 0.55rem;
}

.collateral-table td {
  white-space: nowrap;
  padding: 0.25rem !important;
}

.race-card-course-image {
  width: 80%;
}

#race-numbers {
  background-color: #000000;
  padding: 1rem;
}

#race-numbers-bottom {
  background-color: #000000;
  padding: 0.5rem;
}

.sticky-race-numbers {
  position: fixed;
  z-index: 10;
  top: 10vh;
  width: 100%;
}

.tab-header-clicked {
  background-color: #000000;
  color: #ffffff;
}

.tab-header-clicked:hover {
  background-color: #000000 !important;
  color: #ffffff !important;
}

.finishing-position-icon {
  width: 1.2rem;
  box-shadow: 2px 3px 4px 0 rgba(0, 0, 0, 0.35);
  border-radius: 50%;
}

.finishing-position-icon:hover {
  box-shadow: 2px 3px 8px 0 rgba(0, 0, 0, 0.8);
  cursor: pointer;
  position: relative;
}

.back-to-top-button {
  position: fixed;
  bottom: 5rem;
  right: 0;
  width: 100px;
  height: 100px;
  transform: rotate(180deg);
}

.collateral-header {
  background-color: black;
}

.collateral-table {
  margin-top: 0.6rem;
}

.collateral-grouping {
  border-top: solid 2px #000000;
  border-bottom: solid 2px #000000;
}

.field-statistics {
  border: solid 2px black;
  border-radius: 4px;
  line-height: 1rem;
  padding: 0.2rem 0;
}

.field-statistics table {
  text-align: center;
}

.field-statistics td {
  font-size: 0.5rem;
  text-align: right;
  line-height: 0.7rem;
}

.race-course-title-logo {
  width: 70%;
}

@media (min-width: 576px) {
  .race-number-button {
    font-size: 0.8rem;
  }

  .field-statistics td {
    font-size: 0.65rem;
    line-height: 1.5em;
  }

  td {
    font-size: 0.9rem;
  }

  .extra-info-button {
    font-size: 1rem;
  }

  .race-course-title-logo {
    width: 50%;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: landscape) {
  .finishing-position-icon {
    width: 1.5rem;
  }
}

@media only screen and (min-device-width: 768px) and (max-device-width: 1200px) and (orientation: portrait) {
  .finishing-position-icon {
    width: 1.5rem;
  }
}

@media only screen and (min-device-width: 0px) and (max-device-width: 1200px) and (orientation: landscape) {
  .race-card-course-image {
    width: 60%;
  }

  td {
    font-size: 1rem;
  }

  .extra-info-button {
    font-size: 1.1rem;
  }

  .race-card-info-header {
    font-size: 1.4rem;
  }
}

@media (min-width: 780px) {
  .race-card-course-image {
    width: 52%;
  }

  .race-card-scroll-header {
    font-size: 1rem !important;
  }
}

@media (min-width: 1200px) {
  .finishing-position-icon {
    margin: 2px;
    width: 1.7rem;
  }

  .race-card-wrapper {
    padding-bottom: 1rem;
  }

  .race-card-info-header {
    font-size: 1.3rem;
  }

  .sticky-race-numbers {
    top: 0 !important;
    width: 83.333333%;
  }

  h1 {
    font-size: 3rem;
  }

  .race-card-subheader {
    width: auto;
    position: absolute;
    left: 3.5rem;
    top: 5rem;
  }

  .race-number-button {
    font-size: 1.2rem;
    margin-right: 0.2rem;
    width: 7%;
  }

  td {
    font-size: 0.8rem;
  }

  .extra-info-button {
    font-size: 1.2rem;
  }

  .back-to-top-button {
    bottom: 0;
  }

  .field-statistics td {
    font-size: 1.05rem;
    line-height: 1.4rem;
  }
}

@media (min-width: 1260px) {
  td {
    font-size: 1.2rem;
  }

  h1 {
    margin-top: 0.5rem;
    margin-bottom: 0 !important;
  }
}
</style>
